import { GuernseyProps } from "../../components/shared/GuernseyMulti/Guernsey.types";
import GuernseyMulti from "../../components/shared/GuernseyMulti/GuernseyMulti";
import { useController, useFormContext } from "react-hook-form";
interface Props extends GuernseyProps {
  id: string;
}
const GuernseyMultiInput = ({ value, id, ...rest }: Props) => {
  const setValue = useFormContext()?.setValue;
  const { field } = useController({
    defaultValue: value,
    name: id,
  });
  const handleChange = (v: string) => {
    setValue(id, v);
  };
  return (
    <GuernseyMulti {...rest} value={field.value} onChange={handleChange} />
  );
};
export default GuernseyMultiInput;
